import React from 'react';
import { DatePicker } from 'antd';
import dayjs, { type Dayjs } from 'dayjs';

const { RangePicker } = DatePicker;

export interface TripDateRangeValue {
  startDate: string | null;
  endDate: string | null;
}

interface TripDateRangePickerProps {
  value?: TripDateRangeValue;
  onChange?: (value: TripDateRangeValue) => void;
  startDatePlaceholder?: string;
  endDatePlaceholder?: string;
  id?: string;
  style?: React.CSSProperties;
  /** Disable dates that return true (e.g. outside trip range) */
  disabledDate?: (current: Dayjs) => boolean;
}

const toDateString = (d: Dayjs | null): string | null =>
  d && d.isValid() ? d.format('YYYY-MM-DD') : null;

const TripDateRangePicker: React.FC<TripDateRangePickerProps> = ({
  value,
  onChange,
  startDatePlaceholder = 'Start date',
  endDatePlaceholder = 'End date',
  style,
  disabledDate,
}) => {
  const rangeValue: [Dayjs | null, Dayjs | null] | null =
    value?.startDate || value?.endDate
      ? [
          value?.startDate ? dayjs(value.startDate, 'YYYY-MM-DD') : null,
          value?.endDate ? dayjs(value.endDate, 'YYYY-MM-DD') : null,
        ]
      : null;

  const handleChange = (dates: [Dayjs | null, Dayjs | null] | null): void => {
    if (!dates) {
      onChange?.({ startDate: null, endDate: null });
      return;
    }
    const [sd, ed] = dates;
    onChange?.({
      startDate: toDateString(sd),
      endDate: toDateString(ed),
    });
  };

  return (
    <RangePicker
      value={rangeValue}
      onChange={handleChange}
      format="MMM D, YYYY"
      placeholder={[startDatePlaceholder, endDatePlaceholder]}
      allowClear
      style={{ width: '100%', ...style }}
      disabledDate={disabledDate}
    />
  );
};

export default TripDateRangePicker;
